import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "homepage" }

import MainVisual from "./main/MainVisual.vue";
import MainVisualSp from "./main/MainVisualSp.vue";
import UserCompany from "./main/UserCompany.vue";
import BvFeature from "./main/BvFeature.vue";
import ArVrInfo from "./main/ArVrInfo.vue";
import ImageVideo from "./main/ImageVideo.vue";
import companyPr from "./main/CompanyPr.vue";
import ClassRoomMission from "./main/ClassRoomMission.vue";
import LessonEventMission from "./main/LessonEventMission.vue";
import UserReviews from "./main/UserReviews.vue";
import CreativeAward from "./main/CreativeAward.vue";
import ServiceMotivation from "./main/ServiceMotivation.vue";
import ImageVideo2 from "./main/ImageVideo2.vue";
import QuickStart from "./main/QuickStart.vue";
import ArVrGallery from "./main/ArVrGallery.vue";
import FreeCta from "./main/FreeCta.vue";
import ContactAddress from "./main/ContactAddress.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainSection',
  setup(__props) {

const scrollTop = () => {
  window.scroll({top: 0, behavior: 'smooth'});
}

document.addEventListener("scroll", (event) => {
  if (window.scrollY > 1000) {
    document.getElementById("scrollTop").classList.remove('scrollButton');
  } else {
    document.getElementById("scrollTop").classList.add('scrollButton');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("button", {
      id: "scrollTop",
      class: "scrollButton",
      title: "Go to top",
      onClick: scrollTop
    }, "↑"),
    _createVNode(MainVisual),
    _createVNode(MainVisualSp),
    _createVNode(UserCompany),
    _createVNode(BvFeature),
    _createVNode(ArVrInfo),
    _createVNode(ImageVideo),
    _createVNode(companyPr),
    _createVNode(ClassRoomMission),
    _createVNode(LessonEventMission),
    _createVNode(UserReviews),
    _createVNode(CreativeAward),
    _createVNode(ServiceMotivation),
    _createVNode(ImageVideo2),
    _createVNode(QuickStart),
    _createVNode(ArVrGallery),
    _createVNode(FreeCta),
    _createVNode(ContactAddress)
  ]))
}
}

})